import { SupportedChainId } from 'constants/chains'

type AddressMap = { [chainId: number]: string }

export const UNISWAP_NFT_AIRDROP_CLAIM_ADDRESS = '0x8B799381ac40b838BBA4131ffB26197C432AFe78'

export const V2_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.DUCX]: '0x0893868a8042E5F3215cAC6C8F4741a5B52C56df',
  [SupportedChainId.DUCX_TESTNET]: '0xa4200fb3E5e0556a722d08A6C78f37A3c21396BD',
}
export const V2_ROUTER_ADDRESS: AddressMap = {
  [SupportedChainId.DUCX]: '0xda702971c63bDC30e4Ab3FB02Cff62E4A643107a',
  [SupportedChainId.DUCX_TESTNET]: '0xE11faAdd86689e4c34F3605a737478abD894993d',
}

export const PERMIT2_ADDRESS: AddressMap = {
  [SupportedChainId.DUCX]: '0xBcFceD2641Fb38209FEfC2dB83f725D395D91d2a',
  [SupportedChainId.DUCX_TESTNET]: '0x68bCF5b94A8f1B86DE51f3A5473c9F8C5b4A69B4',
}

// DUCX Testnet addresses
const DUCX_TESTNET_V3_CORE_FACTORY_ADDRESSES = V2_FACTORY_ADDRESSES[SupportedChainId.DUCX_TESTNET]
const CRAT_TESTNET_V3_MIGRATOR_ADDRESSES = ''
const DUCX_TESTNET_MULTICALL_ADDRESS = '0xC8e1f0f76669fF06322E92709Fb391Ef8Fce2d86'
const DUCX_TESTNET_QUOTER_ADDRESSES = '0x5803e430CE1867Ce426993e58Ad76946E622f592'
const DUCX_TESTNET_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = '0x4015c8A91849f09d1105De279B46dc358a9fF3Da'
const DUCX_TESTNET_TICK_LENS_ADDRESSES = '0xc4c55Dd69AcB28B513387C7f50Cc4Ff9712770f8'
const DUCX_TESTNET_POOL_DEPLOYER = '0x6542Ed9D2d550383A82394a819f4438e91a6adFB'
const DUCX_TESTNET_UNIVERSAL_ROUTER_ADDRESS = '0x8411195DA3490B72BcD4D900FcD7A27575B1663f'
const DUCX_TESTNET_V3_INIT_POOL_CODE_HASH = '0x955a8c921a2cebd0053dee4d31f61bab2711d19f629ab77502892ba743c4f25f'

// DUCX addresses
const DUCX_V3_CORE_FACTORY_ADDRESSES = V2_FACTORY_ADDRESSES[SupportedChainId.DUCX]
const DUCXV3_MIGRATOR_ADDRESSES = ''
const DUCX_MULTICALL_ADDRESS = '0x110e7EfB2e7faB0588475BC98b3fC39b8a348111'
const DUCX_QUOTER_ADDRESSES = '0x9817Ff80FD6556f6312a316b59D0C1A436c3deb0'
const DUCX_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = '0x037A7D1f1EC5334A927c725B58Be7Cb3F2a5DB0b'
const DUCX_TICK_LENS_ADDRESSES = '0x3fED917113D415128A83015935E8931B2C85eB3e'
const DUCX_POOL_DEPLOYER = '0xAd2906E3e7aaD16292d2DA0974bbd42CFC0d67c7'
const DUCX_UNIVERSAL_ROUTER_ADDRESS = '0xE3Bd1b2aF786383D37dfF5E0A30EE18C15DC3814'
const DUCX_V3_INIT_POOL_CODE_HASH = '0x955a8c921a2cebd0053dee4d31f61bab2711d19f629ab77502892ba743c4f25f'

/* V3 Contract Addresses */
export const V3_CORE_FACTORY_ADDRESSES: AddressMap = {
  [SupportedChainId.DUCX_TESTNET]: DUCX_TESTNET_V3_CORE_FACTORY_ADDRESSES,
  [SupportedChainId.DUCX]: DUCX_V3_CORE_FACTORY_ADDRESSES,
}

export const V3_MIGRATOR_ADDRESSES: AddressMap = {
  [SupportedChainId.DUCX_TESTNET]: CRAT_TESTNET_V3_MIGRATOR_ADDRESSES,
  [SupportedChainId.DUCX]: DUCXV3_MIGRATOR_ADDRESSES,
}

export const MULTICALL_ADDRESS: AddressMap = {
  [SupportedChainId.DUCX_TESTNET]: DUCX_TESTNET_MULTICALL_ADDRESS,
  [SupportedChainId.DUCX]: DUCX_MULTICALL_ADDRESS,
}

export const ARGENT_WALLET_DETECTOR_ADDRESS: AddressMap = {}

export const QUOTER_ADDRESSES: AddressMap = {
  [SupportedChainId.DUCX_TESTNET]: DUCX_TESTNET_QUOTER_ADDRESSES,
  [SupportedChainId.DUCX]: DUCX_QUOTER_ADDRESSES,
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  [SupportedChainId.DUCX_TESTNET]: DUCX_TESTNET_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
  [SupportedChainId.DUCX]: DUCX_NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
}

export const ENS_REGISTRAR_ADDRESSES: AddressMap = {}

export const TICK_LENS_ADDRESSES: AddressMap = {
  [SupportedChainId.DUCX_TESTNET]: DUCX_TESTNET_TICK_LENS_ADDRESSES,
  [SupportedChainId.DUCX]: DUCX_TICK_LENS_ADDRESSES,
}

export const POOL_DEPLOYER_ADDRESSES: AddressMap = {
  [SupportedChainId.DUCX_TESTNET]: DUCX_TESTNET_POOL_DEPLOYER,
  [SupportedChainId.DUCX]: DUCX_POOL_DEPLOYER,
}

export const UNIVERSAL_ROUTER_ADDRESS: AddressMap = {
  [SupportedChainId.DUCX_TESTNET]: DUCX_TESTNET_UNIVERSAL_ROUTER_ADDRESS,
  [SupportedChainId.DUCX]: DUCX_UNIVERSAL_ROUTER_ADDRESS,
}

export const V3_INIT_POOL_CODE_HASH: AddressMap = {
  [SupportedChainId.DUCX_TESTNET]: DUCX_TESTNET_V3_INIT_POOL_CODE_HASH,
  [SupportedChainId.DUCX]: DUCX_V3_INIT_POOL_CODE_HASH,
}
